import * as React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { Script } from "gatsby";
import type { WrapRootElementBrowserArgs } from "gatsby";
import { customTheme } from "./theme";
//import "./i18n";

const GA_MEASUREMENT_ID = "G-B12LJS5ELF"

// Раньше это делал gatsby-plugin-google-gtag, но он не умеет грузить свой
// скрипт через partytown (см. gatsby-config.ts), поэтому оба тега gtag
// вынесены сюда вручную со strategy="off-main-thread" — это и есть
// единственное отличие от того, что генерировал плагин: те же gtagConfig
// (anonymize_ip/cookie_expires/send_page_view) и респект Do Not Track.
const GtagScripts = () => {
  if (process.env.NODE_ENV !== "production") return null
  return (
    <>
      <Script
        key="gtag-js"
        strategy="off-main-thread"
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
      />
      <Script key="gtag-config" strategy="off-main-thread">
        {`
          if (!(navigator.doNotTrack == "1" || window.doNotTrack == "1")) {
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GA_MEASUREMENT_ID}', {
              optimize_id: 'OPT_CONTAINER_ID',
              anonymize_ip: true,
              cookie_expires: 0,
              send_page_view: false
            });
          }
        `}
      </Script>
    </>
  )
}

export const WrapRootElement = ({ element }: Pick<WrapRootElementBrowserArgs, 'element'>) => (
    // Or ChakraBaseProvider if you only want to compile the default Chakra theme tokens
    <ChakraProvider theme={customTheme}>
        <GtagScripts />
        {element}
    </ChakraProvider>
)